import { Pipe , PipeTransform } from '@angular/core'

@Pipe({
		name: 'formatRole'
})
export class FormatRoleAdmins implements PipeTransform {
		public transform(roles: Array<string>): Array<string> {
				const newRolesFormated: Array<string> = []

				roles.forEach(role => {
						if (role === 'GENERAL_ADMIN') {
								newRolesFormated.push('Administrador Arbolink')
						} else if (role === 'BOTANIC') {
								newRolesFormated.push('Botânico')
						} else if (role === 'CUSTOMER') {
								newRolesFormated.push('Administrador')
						} else if (role === 'USER') {
								newRolesFormated.push('Usuário')
						} else if (role === 'INVENTOR') {
								newRolesFormated.push('Inventariante')
						} else if (role === 'EVALUATOR') {
								newRolesFormated.push('Avaliador')
						} else if (role === 'OPERATOR') {
								newRolesFormated.push('Operador')
						}
				})
				return newRolesFormated
		}
}
